export const REGEX = Object.freeze({
  HEX_COLOR: /^#(?:[0-9a-fA-F]{3}){1,2}$/,
  MONGO_ID: /^[a-fA-F0-9]{24}$/,
  URL: /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/,
  UUID: /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/,
});
